export default __webpack_public_path__ + "static/media/D_wdt_c_cap_0.6c04e8d7.mp3";